import { useEffect } from 'react';

import type { CreateNewObserverOptions } from './intersection-observer';
import { useIsObserved } from './intersection-observer';

export const useOnObserved = (onView?: () => void, options?: CreateNewObserverOptions) => {
  const [ref, isObserved] = useIsObserved(options);

  useEffect(() => {
    if (isObserved) {
      onView?.();
    }
  }, [isObserved]);

  return ref;
};
